module.exports = __webpack_public_path__ + "static/media/back_to_top.b148746b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back_to_top.svg
// module id = 128
// module chunks = 0